export default {
  searchFilter: '',
  data: []
}
